export const environment = {
  production: true,
  appUrl: '/api/',
  hubUrl: '/hub',
  i18nUrl: '',
  baseUrl: '',
  appId: 'zPMO',
  defaultPage: 'HomePage',
  windowsAuthentication: false,
  semanticVersion: '2.0.21'
};